import React from "react";
import './StartNow.css';
import SignUpForm from './Signup';

const StartNow = () => {
  return (
    <section className="call-to-action-section" id="call-to-action">
      <div className="cta-text">
        <h2>Start Your Journey Today</h2>
        <p>Transform job posts into interview success and professional resumes</p>
        <p>Sign up for free and make time for what matters today.</p>
      </div>
      <SignUpForm />
    </section>
  );
};

export default StartNow;